import * as r from 'ramda';
import { call, takeLatest } from 'redux-saga/effects';

import * as actions from './actions';

let buffer = null;
let history = null;

export const setHistory = (x) => {
  history = x;

  if (!r.isNil(buffer)) {
    history.push(buffer);
  }
};

export const navigationSaga = function* () {
  yield takeLatest(actions.navigate, function* ({ payload: path }) {
    buffer = path;

    if (!r.isNil(history)) {
      yield call(history.push, path);
    }
  });
};
